import { DragEndEvent, DragStartEvent } from "@dnd-kit/core"
import { arrayMove } from "@dnd-kit/sortable"
import { useCallback, useMemo, useState } from "react"

import { UseRowOrderProps } from "./types"

export function useRowOrder<T>({
  data,
  extractRowKey,
  onRowReorder,
}: UseRowOrderProps<T>) {
  const rowKeys = useMemo(() => data.map(extractRowKey), [data, extractRowKey])

  const [draggingRowKey, setDraggingRowKey] = useState<string | undefined>(
    undefined
  )

  const onDragStart = useCallback((e: DragStartEvent) => {
    if (typeof e.active.id !== "string") return
    setDraggingRowKey(e.active.id)
  }, [])

  const onDragEnd = useCallback(
    (e: DragEndEvent) => {
      const { active, over } = e
      if (!active || !over) return
      if (active.id === over.id) return
      if (typeof active.id !== "string" || typeof over.id !== "string") return
      const oldIndex = rowKeys.indexOf(active.id)
      const newIndex = rowKeys.indexOf(over.id)
      const newData = arrayMove(data, oldIndex, newIndex)
      onRowReorder?.(newData)
      setDraggingRowKey(undefined)
    },
    [onRowReorder, data, rowKeys]
  )

  return {
    rowKeys,
    draggingRowKey,
    onDragStart,
    onDragEnd,
  }
}
